import { toast } from 'react-toastify';

const TOAST_OPTIONS = {
  autoClose: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const toastSuccess = (message) => toast.success(message, TOAST_OPTIONS);
export const toastError   = (message) => toast.error(message,   TOAST_OPTIONS);
export const toastInfo    = (message) => toast.info(message,    TOAST_OPTIONS);
export const toastWarn    = (message) => toast.warn(message,    TOAST_OPTIONS);
